import {useParams} from 'react-router-dom';
import {UserType} from '../backend/enums/user-type';
import {UsersRepository} from '../repositories/users';
import {AxiosError} from 'axios';
import type {AffiliatedUser} from '../backend/responses/affiliated-user';
import {useFetchAllItems} from './fetch-all-items';

export type FetchEntityUsersOpts = {
  /** `true/false` means active/inactive users. `undefined` means any users. */
  activeUsers?: boolean;
  userType?: UserType;
  entityId?: string;
  enabled?: boolean;
};

export type FetchEntityUsersResult = {
  items?: AffiliatedUser[];
  isLoading: boolean;
  error?: AxiosError<unknown, any>;
};

export function useFetchEntityUsers(opts?: FetchEntityUsersOpts): FetchEntityUsersResult {
  const {entityId} = useParams<{entityId: string}>();
  const {items, isLoading, error} = useFetchAllItems({
    fetchFunction: async ({limit, skip}) => {
      const activationStates =
        opts?.activeUsers !== null && opts?.activeUsers !== undefined
          ? // true or false means only active or inactive users
            [opts?.activeUsers]
          : // undefined means any users(active and inactive)
            undefined;

      return UsersRepository.instance.getAffiliatedUsers(opts?.entityId ?? entityId ?? '', {
        type: opts?.userType ?? UserType.Senior,
        activationStates,
        limit,
        skip,
      });
    },
    enabled: opts?.enabled,
    deps: [entityId],
  });

  return {
    items,
    isLoading,
    error,
  };
}
